"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sigma = exports.MouseCaptor = exports.QuadTree = exports.Camera = void 0;
/**
 * Sigma.js Library Endpoint
 * =========================
 *
 * The library endpoint.
 * @module
 */

var sigma_1 = __importDefault(require("./sigma"));

exports.Sigma = sigma_1.default;

var camera_1 = __importDefault(require("./core/camera"));

exports.Camera = camera_1.default;

var quadtree_1 = __importDefault(require("./core/quadtree"));

exports.QuadTree = quadtree_1.default;

var mouse_1 = __importDefault(require("./core/captors/mouse"));

exports.MouseCaptor = mouse_1.default;
exports.default = sigma_1.default;